import { useEffect } from 'react';
import useOffersStuff from '../useOffersStuff';
import { OfferKindEnum } from '../../../../services/exports/Constants';
import useModalRouter from '../../../../modules/mobile/common/hooks/useModalRouter';
import useMobileApp from '../../../../hooks/mobile-app/useMobileApp';
import useAppMethods from '../../../../hooks/utility/useAppMethods';
import { Offer } from '../../../../services/exports/Interfaces';
import { Modals } from '../../../../modules/mobile/exports/Enums';
import useBasket from '../../../../hooks/basket/useBasket';

const useWatchFreeItemByMinSpendValueThreshold = () => {
  const { unlockedOffers, appliedOffers } = useOffersStuff();
  const freeItemOffer = unlockedOffers.find((offer) => offer.kind === OfferKindEnum.FreeItemByMinSpendValue);
  const isAvailable =
    freeItemOffer &&
    appliedOffers?.length &&
    appliedOffers.every((offer) => offer.kind !== OfferKindEnum.FreeItemByMinSpendValue);
  const { openModal } = useModalRouter();
  const { isMobileApp } = useMobileApp();
  const { toggleFreeItemsModal } = useAppMethods();
  const { originalItems } = useBasket();
  const openFreeItemsModal = (offer: Offer) => {
    if (!isMobileApp) {
      toggleFreeItemsModal({ openModal: true, offer });
      return;
    }

    openModal({
      id: Modals.FreeItemsModal,
      props: {
        offer,
      },
    });
  };

  useEffect(() => {
    if (!isAvailable) {
      return;
    }

    const timeout = setTimeout(() => openFreeItemsModal(freeItemOffer), 200);

    return () => clearTimeout(timeout);
  }, [isAvailable, freeItemOffer, originalItems]);
};

export default useWatchFreeItemByMinSpendValueThreshold;
